
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/step",
      function () {
        return require("private-next-pages/joy-ui/api/step.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/step"])
      });
    }
  